export const findEntityObject = (arrayEntities, entityId) => {
  const entityFound = arrayEntities?.find((entity) => entity?._id === entityId)
  return entityFound
}
